<template>
  <div class="knowledge-weak-point">
    <div class="point-title">
      <div class="point-title__left">
        <p class="left-line"/>
        <p class="left-text">
          <span class="text-bg">薄弱知识点 TOP10</span>
        </p>
        <span class="size-bg">（仅展示掌握程度在60%以下的薄弱知识点）</span>
      </div>
    </div>

    <div class="point-content">
      <el-table
      ref="singleTable"
      :data="overviewData.code_list"
      :header-cell-style="{background:'#F0F2F5',color:'#909399'}"
      style="width: 100%">
      <div slot="empty" class="no-data">
        <emptyContent/>
      </div>
        <el-table-column
          type="index"
          width="50"
          label="序号"
          align="center">
        </el-table-column>
        <el-table-column
          v-for="item in columnName"
          :key="item.prop"
          :label="item.label"
          :prop="item.prop"
          :sortable="item.sortable"
          align="center">
          <template slot-scope="scope">
            <template v-if="item.prop==='avg_score'">
              <span :class="getRightClass(scope.row[item.prop])">
                {{scope.row[item.prop]===-1?'--':scope.row[item.prop]+'%'}}
              </span>
            </template>
            <template v-else-if="item.prop==='tag_name'">
              <span  @click="queryKnowledgeDetail(scope.row)" class="blue">
                {{scope.row[item.prop]}}
              </span>
            </template>
            <template v-else-if="item.prop==='low_score_count'">
                {{scope.row[item.prop]+'人'}}
            </template>
            <template slot-scope="scope" v-else>
              {{scope.row[item.prop]}}
            </template>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center">
          <template slot-scope="scope">
            <el-button
              size="mini"
              type="text"
              @click="queryKnowledgeDetail(scope.row)">
              <div>查看详细</div>
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import emptyContent from './empty-content.vue';

const CLASS_TYPE = 2; // 1为普通班级报告 2为班级对比报告
export default {
  name: 'Knowledge-weak-point',
  components: {
    emptyContent,
  },
  props: {
    overviewData: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      classType: CLASS_TYPE,
      columnName: [{
        label: '知识点名称',
        prop: 'tag_name',
        sortable: false,
      }, {
        label: '平均掌握程度',
        prop: 'avg_score',
        sortable: true,
      }, {
        label: '未掌握学生',
        prop: 'low_score_count',
        sortable: true,
      }],
    };
  },
  methods: {
    // 掌握程度颜色区分
    getRightClass(value) {
      if (value === -1) {
        return 'default';
      }
      if (value >= 70) {
        return 'level2';
      }
      if (value >= 40) {
        return 'level1';
      }
      return 'level3';
    },
    queryKnowledgeDetail(item) {
      let classIds = [];
      classIds = this.overviewData.class_ranking_list.map((items) => items.class_id);
      const { batchId } = this.$route.query;
      this.$router.push({
        path: '/pt/new-detailed',
        query: {
          testId: this.overviewData.test_id,
          testName: this.overviewData.test_name,
          classId: classIds[0],
          classType: this.classType, // 批次测评
          batchId,
          tag_code: item.tag_code,
          subjectName: this.overviewData.subject_name,
          tag_name: item.tag_name,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.knowledge-weak-point{
  padding:20px;
  box-sizing: border-box;
  .point-title{
    &__left{
      display: flex;
      align-items: center;
      .left-line{
        margin:19px 0 20px 0;
        display: block;
        width: 3px;
        height: 16px;
        background: #1890FF;
        border-radius: 3px;
        margin-right: 8px;
      }
      .left-text{
        font-size: 18px;
        height: 25px;
        font-family: 'PingFangSC-Medium', 'PingFang SC';
        font-weight: 500;
        color: #000000;
        line-height: 25px;
        position: relative;
        &:after{
          content:'';
          position: absolute;
          width:100%;
          height:50%;
          left:0;
          bottom:3px;
          background:rgba(230, 162, 60, 0.2);
          border-radius: 16px;
        }
        .text-bg{
          position: relative;
          z-index: 2;
        }
      }
      .size-bg{
        display: block;
        margin-top:2px;
        font-size: 13px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(48, 49, 51, 0.4);
      }
    }
  }
  .point-content{
    .no-data{
      line-height: 1.8;
      padding: 30px 0;
    }
  }
}
.blue{
  color:#1989FA;
}
</style>
